import { Typography } from "@creditsafe/ui-components";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Menu, TextField } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ListSubheaderWrapper,
  MenuItemWrapper,
} from "../../../shared/components/searchable-dropdown/SearchableDropdown";
import { CenteredBox } from "../../../shared/styles/common-styles";
import { User } from "../../../shared/types/user.type";
import { getContactName } from "../../../utils";

export const AssignedTo: React.FC<{
  header: string;
  index: string;
  selectedId?: number;
  updateChipLabels: (key: string, value: string) => void;
  usersMenuList: User[] | undefined;
  setSearchTextValue: (text: string) => void;
  selectedAssignee: (userId: (number | string)[]) => void;
  userSelected: (number | string)[];
  searchText: string;
  showId?: boolean;
}> = ({
  header,
  index,
  updateChipLabels,
  selectedId,
  usersMenuList,
  setSearchTextValue,
  selectedAssignee,
  userSelected,
  searchText,
  showId = true,
}) => {
  const { t: translate } = useTranslation(["profile", "common"]);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [openPopoverId, setOpenPopoverId] = useState<string | null>(null);
  const userId = selectedId ?? 0;
  const [selectedOptionId, setSelectedOptionId] = useState<string | number>(
    userId
  );

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorEl(event.currentTarget);
    setOpenPopoverId(id);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setOpenPopoverId(null);
  };

  const onUserClick = (userId: number | string, name: string) => {
    setSelectedOptionId(userId);
    updateChipLabels("assignedTo", `Assigned To:` + ` ` + name);
    selectedAssignee([userId]);
    setAnchorEl(null);
    setOpenPopoverId(null);
  };

  return (
    <Box component={"span"}>
      <Typography
        key={index}
        aria-label="assigned to"
        variant="h6"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
          handlePopoverOpen(e, header)
        }
      >
        <CenteredBox aria-label="assignedToValue">
          {translate(header)}
          {openPopoverId === header || userSelected.length > 0 ? (
            <FilterAltIcon fontSize="small" />
          ) : (
            <FilterAltOutlinedIcon fontSize="small" />
          )}
        </CenteredBox>
      </Typography>
      <Menu
        id={`popover-${header}`}
        anchorEl={anchorEl}
        open={openPopoverId === header}
        onClose={handlePopoverClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ width: "70%" }}
        style={{ maxHeight: "300px" }}
      >
        <ListSubheaderWrapper className="list-subheader">
          <SearchIcon className="search-icon" />
          <TextField
            size="small"
            className="search-box"
            autoFocus
            placeholder="Search Users..."
            id="dropdown-search"
            value={searchText}
            onChange={(e) => setSearchTextValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
            inputProps={{
              "aria-label": "searchUsers",
              "data-private": "true",
            }}
          />
        </ListSubheaderWrapper>
        {usersMenuList?.map((option: User) => {
          const contactName = getContactName(option);
          if (contactName) {
            return (
              <MenuItemWrapper
                key={`user-${option.userId}`}
                value={option.userId}
                aria-label={`user ${option.userId}`}
                selected={userSelected[0] === option.userId}
                className={`menu-item ${
                  selectedOptionId === option.userId?.toString() ? "active" : ""
                }`}
                onClick={() => onUserClick(option.userId, contactName)}
              >
                <Typography variant="body2" data-private="true">
                  {contactName}
                </Typography>
                {showId && option.userId && (
                  <div className="user-id" data-private="true">
                    ID: {option.userId}
                  </div>
                )}
              </MenuItemWrapper>
            );
          }
        })}
      </Menu>
    </Box>
  );
};
